import hyperdom from 'hyperdom'

export default class FlightPreferences {
  constructor (model) {
    this.model = model
  }

  render () {
    const {exploreFlights} = this.model
    const {preferredAirlines} = this.model.config

    return <div class="u-margin-top-medium">
      <div class="flights__preferences-header">What are your flight preferences?</div>
      <div class="more-options__list">
        <div className="o-form-item">
          <label className="o-form-item__label flights__label" htmlFor="cabin-select">Cabin</label>
          <select binding={[exploreFlights, 'cabin']} id="cabin-select" class="cabin o-form-item__txt-input">
            <option value="any" selected>Any</option>
            <option value="Economy">Economy</option>
            <option value="PremiumEconomy">Premium Economy</option>
            <option value="Business">Business</option>
            <option value="First">First</option>
          </select>
        </div>
        <div className="o-form-item">
          <label className="o-form-item__label flights__label" htmlFor="airline-select">Airline</label>
          <select binding={[exploreFlights, 'airline']} id="airline-select" class="airline o-form-item__txt-input">
            <option value="any" selected>Any</option>
            {preferredAirlines ? preferredAirlines.map(airline => <option value={airline.code}>{airline.name}</option>) : undefined}
          </select>
        </div>
      </div>
    </div>
  }
}
